import React, { ReactNode } from "react";
import { Outlet } from "react-router-dom";

import styles from "./Layout.module.scss";



type Props = {
    headerSlot?: ReactNode,
    sidebarSlot: ReactNode,
}

export const Layout = (props: Props) => {

    return (
        <>
            <div className={styles.layout}>
                {props.sidebarSlot}
                <div className={styles.layoutBelow}>
                    {props.headerSlot}
                    <div className={styles.layoutContent}>
                        <main className={styles.main}><Outlet /></main>
                    </div>
                </div>
            </div>
        </>
    );
};